import { useCallback } from "react";
import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_agency_payment_errors_web",
  stages: {},
  defaultStage: 1,
  goals: {
    confirmation_error: 1
  }
});

export const useTrackAgencyPaymentErrors = () => {
  const trackConfirmationError = useCallback(() => {
    utils.goals.confirmation_error();
  }, []);

  return {
    trackConfirmationError
  };
};

export default utils;
